<div class="header-container">
  <div class="logo">
    <img src="/assets/calingo_logo%201.svg" alt="logo"/>
  </div>

  <div class="nav-container">
    <cpf-small-nav></cpf-small-nav>
  </div>



  <div class="right-part">
    <!--<div class="account" *ngIf="cognitoUser && user">
    <div class="img-container">
      <img [src]="avatarUrl" alt="" *ngIf="avatarUrl">
      <p *ngIf="!avatarUrl">?</p>
    </div>

    <div class="info">
      <div class="name"><p class="body-16">{{ cognitoUser.given_name }} {{ cognitoUser.family_name }}</p></div>
      <div class="email"><p class="body-14">{{ cognitoUser.email }}</p></div>
    </div>
  </div>-->

  <div class="notification-button" [class.unread]="haveUnreadNotifications()" (click)="toggleNotificationContainer()">
    <div class="bell"></div>
  </div>
</div>
</div>

<div class="notification-place">
  <div class="notification-container" [class.open]="notificationContainerOpen">
    <div class="header">
      <h4>{{ 'header.notifications.title'|translate }}</h4>
      <div class="close" (click)="toggleNotificationContainer()">
        <mat-icon svgIcon="expand-up"></mat-icon>
      </div>
    </div>

    <div class="content">
      @if (notifications.length > 0) {
        @for (notification of notifications; track notification) {
          <div class="item" [ngClass]="getNotificationStyle(notification)">
            <div class="item-icon">
              <mat-icon [svgIcon]="getNotificationStyle(notification)"></mat-icon>
            </div>
            <div class="item-content">
              <div class="item-header">
                <div class="item-title">
                  <span class="subtitle-14">
                    {{ getNotificationTranslationKey(notification, 'title') | translate:notification.values }}
                  </span>
                </div>
                <div class="close" (click)="markNotificationAsRead(notification)">
                  <mat-icon svgIcon="cross"></mat-icon>
                </div>
              </div>
              <div class="item-text">
                <p class="body-12">
                  {{ getNotificationTranslationKey(notification, 'text') | translate:notification.values }}
                </p>
                @if (notification.comment) {
                  <p class="body-12">
                    {{ notification.comment }}
                  </p>
                }
              </div>
              @if (isMeikoVoucher(notification)) {
                <div class="coupon-row">
                  <button
                    class="coupon-code"
                    [cdkCopyToClipboard]="notification.values['couponCode']"
                    (cdkCopyToClipboardCopied)="onCouponCopied(notification.id)">
                    {{ notification.values['couponCode'] }}
                    <mat-icon svgIcon="copy"></mat-icon>
                  </button>
                  <span class="copy-feedback" [class.visible]="copiedNotificationId === notification.id">
                    {{ 'header.notifications.meiko-voucher.coupon-copied' | translate }}
                  </span>
                </div>
              }
              @if (isMeikoVoucher(notification)) {
                <div class="item-footer">
                  <a class="link"
                    [href]="notification.values['partnerUrl']"
                    target="_blank"
                    rel="noopener noreferrer">
                    <span class="text-button-12">
                      {{ getNotificationTranslationKey(notification, 'link') | translate:notification.values }}
                    </span>
                    <mat-icon svgIcon="expand-up"></mat-icon>
                  </a>
                </div>
              } @else {
                <div class="item-footer">
                  <div class="link">
                    <span class="text-button-12">
                      {{ getNotificationTranslationKey(notification, 'link') | translate }}
                    </span>
                    <mat-icon svgIcon="expand-up"></mat-icon>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      } @else {
        <div class="empty-notifications">
          <p class="body-14">{{ 'header.notifications.empty'|translate }}</p>
        </div>
      }

    </div>
  </div>
</div>
